import { PressReleaseArticleHero as schema } from 'web/schemas/contentful/_schema.mjs';
import { fakeProps } from 'web/schemas/contentfulTestData';

const TestData = {
  img: '/assets/test.png',
  header:
    'Engel & Völkers Professionals Recognized on the LGBTQ+ Real Estate Alliance Top Producers List',
  bodyText:
    "In the world of coding and tests, where data reigns supreme, we use test data to do our best and make sure our code's a dream. We input names like Alice and Bob, and numbers like one and two, and with each test, we let out a sob, hoping our code will pull through. We create test data with such care, making sure each value's right, for if we don't, it's only fair that our code won't shine so bright. So here's to test data, our trusty friend, without which we'd be lost, for with it, our code we can defend, no matter the cost.",
  author: 'Nicole Domingues',
  publicationDate: '2022-11-26T00:59:52.824Z',
  ctaUrl: 'https://www.hzdg.com/',
};

export default fakeProps(schema, TestData);
